import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Constants from "../../constants";

const initialState = {
    userAccountsLoader: false,
};

export const UserAccountsSearchJSON = createAsyncThunk(
    'admin/UserAccountsSearchJSON', async(credentials) => {
        try {
            const response = await fetch(Constants.Api.commonUrl+`UserAccountsSearchJSON?Token=${credentials.token}&CID=${credentials.cid}&SearchCID=${credentials.searchCid}&SearchSecurityGroup=${credentials.searchSecurityGroup}&SearchCriteria=${credentials.searchCriteria}`, {
                method: 'GET'
            })
            const data = await response.json();
            return data;
        } catch (err) {

        }
    }
)

export const UserAccountsSearchSlice = createSlice({
    name: 'AdminUserAccountsSlice',
    initialState,
    reducers: {

    },
    extraReducers: {
        [UserAccountsSearchJSON.pending]: (state, action) => {
            state.userAccountsLoader = true;
        },
        [UserAccountsSearchJSON.fulfilled]: (state, action) => {
            state.userAccountsLoader = false;
        },
        [UserAccountsSearchJSON.rejected]: (state, action) => {
            state.userAccountsLoader = false;
        }
    }
})

export default UserAccountsSearchSlice.reducer;